import { FetchArcheidosResultsSortTypes } from './archeidosTypes';

export const INITIAL_ARCHEIDOS_RESULTS_FILTERS = {};
export const INITIAL_ARCHEIDOS_RESULTS_PAGE = 1;
export const INITIAL_ARCHEIDOS_RESULTS_SORT = [
  FetchArcheidosResultsSortTypes.CREATED_AT_DESC
];
export const INITIAL_ARCHEIDOS_RESULTS_LIMIT = 10;

export const enum ArcheidosPermissions {
  READ_ARCHEIDOS_INDEX_PAGE = 'read_archeidos_index_page',
  READ_ARCHEIDOS_RESULTS_WORKFLOW_FILTER = 'read_archeidos_results_workflow_filter',
  READ_ARCHEIDOS_RESULTS_WORKFLOW_FILTER_COUNT = 'read_archeidos_results_workflow_filter_count',
  READ_ARCHEIDOS_SECONDARY_MENU_CONTENT = 'read_archeidos_secondary_menu_content',
  READ_ARCHEIDOS_RESULT_DOWNLOAD_ANSWER_BUTTON = 'read_archeidos_result_download_answer_button',
  READ_ARCHEIDOS_RESULT_COMPARISON_BUTTON = 'read_archeidos_result_comparison_button',
  READ_ARCHEIDOS_STYLE_TRANSFER_WORKFLOW = 'read_archeidos_style_transfer_workflow',
  READ_ARCHEIDOS_IMAGE_GENERATOR_WORKFLOW = 'read_archeidos_image_generator_workflow',
  READ_ARCHEIDOS_WORKFLOWS_VERSION = 'read_archeidos_workflows_versions',
  CHANGE_ARCHEIDOS_WORKFLOWS_VERSION = 'change_archeidos_workflows_version',
  READ_ARCHEIDOS_RESULT_STATUS = 'read_archeidos_result_status'
}

export const enum ArcheidosFormFieldTypes {
  BUTTON_CHOICES = 'button_choices',
  IMAGE = 'image',
  INPUT = 'input',
  SLIDER = 'slider',
  TEXTAREA = 'textarea'
}

export const ARCHEIDOS_STYLE_TRANSFER_FORM = 'archeidos-style-transfer-form';
export const ARCHEIDOS_IMAGE_GENERATOR_FORM = 'archeidos-image-generator-form';

export enum ArcheidosWorkflowsEnum {
  STYLE_TRANSFER = 'style_transfer',
  CHARACTER_ENCHANCER = 'character_enchancer',
  GENERAL_ENCHANCER = 'general_enchancer',
  IMAGE_GENERATOR = 'image_generator',
  INSPIRATION_GENERATOR = 'inspiration_generator',
  UPSCALER = 'upscaler'
}
